import $ from "jquery";
import "../bootstrap/js/bootstrap.min.js";
import './country-codes.js';
import './gppy-change-avatar.js';
import './gppy-change-password.js';
import './gppy-change-username.js';
import './gppy-change-invoicedata.js';
import './gppy-delete-account.js';
import './gppy-rename-user.js';
import './gppy-cancel-subscription.js';
import GPPYLoginForm from './gppy-login-form.svelte';
import GPPYRegisterForm from "./gppy-register-form.svelte";
import GPPYContactForm from "./gppy-contact-form.svelte";
import './gppy-update-notifications.js';
import './gppy-project.js';
import './gppy-pricing.js';
import './gppy-verify-transaction.js';
import './gppy-comments.js';
import './gppy-faq.js';
import './../less/style.less';
import {getCookie} from './gppy-misc.js';

export let GPPY = {
    logged: function() {
        return !$('.notlogged').length;
    },

    premiumAccess: function() {
        return $('.premiumAccess').length;
    },

    init: function() {
        GPPY.initcsrf();
        GPPY.removeLegacyCookies();
        GPPY.trialButtons();
        GPPY.seemoreAjaxButtons();

        //HP specific
        if ($('.hp').length || $('.pricingpage').length)
            $('footer .projectlane').addClass("animated");

        let showLoginFormFunc = () => {
            let component = new GPPYLoginForm({
                target: document.body,
                props: {}
            });
            component.showLoginForm();
        };
        $('.notlogged .signInLink').click(showLoginFormFunc);

        if ($('.notlogged').length) {
            let u = new URL(location.href);
            if (u.searchParams.get("login") === "true")
                showLoginFormFunc();
        }

        $('.contactLink').click(() => {
            let component = new GPPYContactForm({
                target: document.body,
                props: {}
            });
            component.showContactForm();
        });
    },

    trialButtons: function() {
        $('.notlogged .buttonTryDemo').each(function(i,el) {
            $(el).removeAttr('href').click(function() {
                let component = new GPPYRegisterForm({
                    target: document.body,
                    props: {
                        nextAction: GPPY.redirectToApp
                    }
                });
                component.showRegisterForm();
            });
        });
    },

    seemoreAjaxButtons: function() {
        $('.seemoreAjax').click((e) => {
            e.preventDefault();
            let url = $(e.target).attr('data-url');
            let page = parseInt(url.split('/')[url.split('/').length - 1]);
            let urlWithoutPage = url.split('/');
            urlWithoutPage.pop();
            urlWithoutPage = urlWithoutPage.join('/');
            fetch(url).then(res => res.text()).then((res) => {
                $(e.target).parent().prev().append(res);
                if ($(e.target).parent().prev().find('.seemoreAjaxStop').length)
                    $(e.target).parent().remove();
                else
                    $(e.target).attr('data-url', urlWithoutPage + "/" + (page + 1));
            })
            return false;
        })
    },

    redirectToApp: function() {
        let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";
        window.location = STATICDJURL + '/gpjs/index.html?lang='+lang;
    },

    removeLegacyCookies: function() {
        var cookieNames = document.cookie.split(/=[^;]*(?:;\s*|$)/);

        for (var i = 0; i < cookieNames.length; i++) {
            if (cookieNames[i].match("^CakeCookie")) {
                document.cookie = cookieNames[i]  + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
        }
    },

    initcsrf: function() {
        var csrftoken = getCookie('csrftoken');
        function csrfSafeMethod(method) {
            // these HTTP methods do not require CSRF protection
            return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
        }
        $.ajaxSetup({
            beforeSend: function(xhr, settings) {
                if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                    xhr.setRequestHeader("X-CSRFToken", csrftoken);
                }
            }
        });
    }
}

$('document').ready(GPPY.init);


window.GPPY = GPPY;